import {
  CtaBuilderFn,
  InstantAnswerBuilderFn,
  InstantAnswerContext,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";
import { StringContextType } from "@faire/web-api--source/faire/translator/StringContextType";
import brandPortalOrdersbrandOrderTokenEdit from "@faire/web-api--source/routes/brand-portal/orders/brandOrderToken/edit";
import React from "react";

import { ViewOrdersCTA } from "./ctas";
import { EditOrderInformationIA } from "./instantAnswersComponents/orders/EditOrderInformationIA";

export const editOrderInformation: InstantAnswerBuilderFn = (
  strictLocalize
) => ({
  titleBuilder: (context) => getAnswer(context, strictLocalize).getTitle(),
  descriptionBuilder: (context) =>
    getAnswer(context, strictLocalize).getDescription(),
  primaryCtaBuilder: {
    textBuilder: (context) => {
      return getPrimaryCTA(context, strictLocalize)?.label;
    },
    linkBuilder: (context) => {
      return getPrimaryCTA(context, strictLocalize)?.getLink?.();
    },
  },
});

const getAnswer = (
  context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () => EDIT_ORDER_TITLE(strictLocalize),
    getDescription: () => EDIT_ORDER_DESCRIPTION(context),
  };
};

const EDIT_ORDER_TITLE = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "Edit order information",
    description: {
      text: "Title for the instant answer about editing items in an order",
    },
  });

const getPrimaryCTA: CtaBuilderFn = (context, strictLocalize) => {
  const brandOrderToken = context.brandOrder?.brand_order?.token;
  if (brandOrderToken) {
    return {
      label: strictLocalize({
        defaultMessage: "Edit order",
        description: {
          text: "Primary CTA for the instant answer about editing items in an order",
          stringDescriptors: [StringContextType.CALL_TO_ACTION],
        },
      }),
      getLink: () => brandPortalOrdersbrandOrderTokenEdit(brandOrderToken),
    };
  }
  return ViewOrdersCTA(strictLocalize);
};

const EDIT_ORDER_DESCRIPTION = (context: InstantAnswerContext) => {
  return <EditOrderInformationIA context={context} />;
};
